import { createSelector } from 'reselect';
import { ContentManagementState } from 'framework/modules/contentmanagement/contentmanagement.interfaces';

const getRowEditorData = (state: ContentManagementState) => {
  const mobileLayout = state.contentmanagement.rowEditorData?.settings?.mobileLayout;
  return { mobileLayout: mobileLayout || 'stacked' };
};

export const getRowLayout = createSelector([getRowEditorData], ({ mobileLayout }) => mobileLayout);
